module.exports = __webpack_public_path__ + "img/baner1_large.fea31754.webp";